import React from 'react';
import { IoIosArrowUp } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

function FrequentlyAskedQuestions(props) {
  const { frequentlyAskedQuestionsRef } = props;
  const { t } = useTranslation();
  // eslint-disable-next-line
  const [idSelectQuestion, setIdSelectQuestion] = React.useState();
  const handleShowAnswer = faqIndex => {
    if (faqIndex === idSelectQuestion) {
      setIdSelectQuestion();
    } else {
      setIdSelectQuestion(faqIndex);
    }
  };
  const renderFaqList = () => {
    return t('faq.faqList', { returnObjects: true }).map((faq, faqIndex) => {
      return (
        <div
          key={faqIndex}
          className={
            'w-full flex flex-row p-[0.625rem] border border-secondary h-[5rem] overflow-hidden justify-between question' +
            (idSelectQuestion === faqIndex ? ' h-[9.5rem] lg:h-[8rem]' : '')
          }
          style={{
            transition: 'height 0.75s ease',
          }}
          onClick={() => handleShowAnswer(faqIndex)}
        >
          <div>
            <div className="text-[1rem] px-[1.25rem] py-[1rem]">{faq.question}</div>
            <div className="p-[0.625rem]">{faq.answer}</div>
          </div>
          <div className="p-[1rem] cursor-pointer">
            <IoIosArrowUp
              className="text-[1.5rem]"
              style={{
                transition: 'transform 0.75s ease',
                transform: faqIndex === idSelectQuestion ? 'rotate(180deg)' : ' rotate(0deg)',
              }}
            />
          </div>
        </div>
      );
    });
  };
  return (
    <div className="w-full py-[6.25rem]" ref={frequentlyAskedQuestionsRef}>
      <div className="w-10/12 m-auto">
        <div className="mb-[1rem] mb-[1.5rem]">
          <h2 className="text-primary font-bold text-[1.875rem] text-center">{t('faq.title')}</h2>
        </div>
        <div className="overflow-hidden">{renderFaqList()}</div>
      </div>
    </div>
  );
}
export default FrequentlyAskedQuestions;
